import React, { useEffect, useCallback, lazy, Suspense } from "react";
import { getBaseUrl } from "../../utils/config.utils";
import { useAuth } from "../auth/Auth";
import { STAGING_LOGIN } from "../../constants/routes.constants";
import { useHistory } from "react-router-dom";
import TaletreeLoader from '../../components/views/taletree_loader/TaletreeLoader.js';
const HomeRoute = lazy(() => import("../routes/HomeRoute"));

export default function StagingAuth() {
  const BASE_URL = getBaseUrl();
  const history = useHistory();
  const { staging } = useAuth();

  //Memoized redirect function
  const handleRedirect = useCallback(() => {
    if (BASE_URL.includes("staging.taletree.com") && !staging) {
      history.replace(STAGING_LOGIN); // `replace` prevents back button issue
    }
  }, [BASE_URL, staging, history]);

  useEffect(() => {
    handleRedirect();
  }, [handleRedirect]); // Single useEffect with dependencies

  return (
    <Suspense fallback={<div style={{ background: "url('https://storage.googleapis.com/tale-tree-e09a94c4/static/868182675aeda24c9f73da76084d2271.jpg')", backgroundSize: "100%", backgroundRepeat: "no-repeat", height: "100vh", marginBottom: "-50px", }}> <div style={{ width: "200px", height: "auto", margin: "0 auto", transform: "translateY(50%)" }}>  <TaletreeLoader />  </div>  </div>}>
      <HomeRoute />
    </Suspense>
  );
}